<template>
  <div>
    <page-content-toolbar
      :title="$t('global.developerGuide')"
    />

    <v-card
      elevation="0"
      class="mx-auto"
    >
        <v-card-title>API Documentation</v-card-title>
        <v-card-text>
          {{ $t('developerGuide.apiDocumentation') }}
        </v-card-text>
        <v-card-actions>
          <v-btn
              class="raison-btn"
              href="https://doc-staging.ai-raison.com/"
              target="_blank"
            >
              <v-icon left>mdi-api</v-icon>
              {{ $t('developerGuide.viewApiDocumentation') }}
            </v-btn>
        </v-card-actions>
<!--
        <v-card-title>{{ $t('developerGuide.apiKey') }}</v-card-title>
        <v-card-text>
          <v-row class="ma-0 pa-0">
            <v-col cols="8" class="ma-0 pa-0">
              <v-text-field
                :label="$t('developerGuide.apiKey')"
                :value="apiKey"
                solo
                readonly
              />
            </v-col>
            <v-col cols="4"  class="ma-0 px-2 py-0">
              <v-btn
                class="raison-btn"
                fab
                small
              >
                <v-icon>mdi-trash-can-outline</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      -->

    </v-card>
  </div>

</template>

<script>
import PageContentToolbar from '@/components/layout/PageContentToolbar';

import ProjectPageMixin from '@/mixins/project-page-mixin.js'


export default {
  name: 'DeveloperGuide',

  components: {
    PageContentToolbar,
  },

  mixins: [ ProjectPageMixin ],

  data () {
    return {
      apiKey: 'FAKE_API_KEY',
    };
  },

  methods: {

    // downloadSource () {
    //   let element = document.createElement('a');
    //   element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(this.source.source));
    //   element.setAttribute('download', 'openapi.json');

    //   element.style.display = 'none';
    //   document.body.appendChild(element);

    //   element.click();

    //   document.body.removeChild(element);
    // },
  },

  created() {
  },
}
</script>

<style>
</style>
